export const COMPANY = {
  name: "BÂTI 360",
  phone: "07 57 51 33 75",
  phoneHref: "tel:+33757513375",
  email: "contact@bati360.com",
  address: "Avenue Roland Moreno",
  city: "77124 Chauconin-Neufmontiers",
  zone: "Paris et Île-de-France",
};

export const SOCIALS = [
  { name: "Instagram", url: "https://www.instagram.com/bati.360", key: "instagram" },
  { name: "Facebook", url: "https://www.facebook.com/share/1CAMa3rpFU/", key: "facebook" },
  { name: "LinkedIn", url: "https://www.linkedin.com/in/william-quinteiro-949388b2", key: "linkedin" },
];

export const NAV_LINKS = [
  { label: "Accueil", to: "/" },
  { label: "Réalisations", to: "/realisations" },
  { label: "Vidéos", to: "/videos" },
  { label: "Services", to: "/services" },
  { label: "À propos", to: "/a-propos" },
  { label: "Contact", to: "/contact" },
];

export const CHANTIER_VIDEOS = [
  {
    src: "/chantiers/surelevation/chantier-video.mp4",
    poster: "/chantiers/surelevation/chantier-video-poster.webp",
    title: "Surélévation & rénovation complète — visite du chantier",
    subtitle: "Ossature bois, charpente, réseaux et second œuvre",
    project: "/realisations/surelevation-en-ossature-bois-et-renovation-complete-d-une-maison-ile-de-france",
  },
  {
    src: "/chantiers/surelevation/chantier-video-2.mp4",
    poster: "/chantiers/surelevation/chantier-video-2-poster.webp",
    title: "Surélévation — la toiture vue du ciel",
    subtitle: "Vue drone du chantier et de la couverture",
    project: "/realisations/surelevation-en-ossature-bois-et-renovation-complete-d-une-maison-ile-de-france",
  },
  {
    src: "/chantiers/etancheite/timelapse-toiture.mp4",
    poster: "/chantiers/etancheite/timelapse-toiture-poster.webp",
    title: "Étanchéité d'une toiture-terrasse — timelapse",
    subtitle: "Le chantier filmé jour après jour",
    project: "/realisations/etancheite-d-une-toiture-terrasse-ile-de-france",
  },
];

export const IMAGES = {
  hero: "/hero-chantier.webp",
  blueprints: "/chantiers/surelevation/09-facade-echafaudage.webp",
  steel: "/chantiers/surelevation/04-charpente-bois.webp",
  framework: "/chantiers/surelevation/06-toiture-charpente.webp",
  chantier: "/chantiers/surelevation/03-solivage-plancher.webp",
  interior1: "/chantiers/surelevation/13-cuisine-ilot.webp",
  interior2: "/chantiers/surelevation/15-sdb-finie.webp",
  interior3: "/chantiers/surelevation/14-piece-de-vie-escalier.webp",
  house: "/chantiers/isolation/01-facade-ite-echafaudage.webp",
  engineer: "/chantiers/surelevation/10-reseaux-cvc.webp",
  roof: "/chantiers/couverture-zinc/01-toiture-vue-ensemble.webp",
  before: "/chantiers/surelevation/avant-16x10.webp",
  after: "/chantiers/surelevation/apres-16x10.webp",
};

export const EXPERTISE = [
  {
    num: "01",
    title: "Rénovation intérieure",
    image: IMAGES.interior1,
    items: ["Rénovation complète d'appartements et maisons", "Plâtrerie et faux plafonds", "Peinture", "Carrelage", "Salle de bains"],
  },
  {
    num: "02",
    title: "Structure & ouvertures",
    image: IMAGES.steel,
    items: ["Charpente bois et métal", "Création et modification d'ouvertures", "Métallerie et structures acier", "Verrières"],
  },
  {
    num: "03",
    title: "Couverture & étanchéité",
    image: "/chantiers/etancheite/01-membrane-applicateur.webp",
    items: ["Couverture", "Zinguerie", "Étanchéité"],
  },
  {
    num: "04",
    title: "Isolation & performance",
    image: IMAGES.house,
    green: true,
    items: ["Rénovation énergétique", "Isolation intérieure", "Isolation extérieure"],
  },
  {
    num: "05",
    title: "Lots techniques",
    image: IMAGES.engineer,
    items: ["Électricité", "Plomberie", "Climatisation et ventilation"],
  },
  {
    num: "06",
    title: "Menuiseries & extérieurs",
    image: null,
    items: ["Menuiseries", "Terrasse et aménagement extérieur"],
  },
];

export const METHOD_STEPS = [
  { num: "01", title: "Étude du projet", text: "Analyse de votre demande, de vos plans et de vos objectifs pour cadrer le projet dès le départ." },
  { num: "02", title: "Visite technique", text: "Relevés sur place, diagnostic des contraintes du bâtiment et échanges avec vous sur les solutions possibles." },
  { num: "03", title: "Chiffrage détaillé", text: "Un devis clair, poste par poste, sans zone d'ombre : vous savez exactement ce que comprend le chantier." },
  { num: "04", title: "Préparation du chantier", text: "Planification, commande des matériaux, autorisations et organisation des interventions." },
  { num: "05", title: "Coordination des travaux", text: "Pilotage de tous les corps de métier, suivi régulier et points d'avancement avec vous." },
  { num: "06", title: "Livraison", text: "Réception du chantier ensemble, vérification des finitions et remise des documents." },
];

export const ENGAGEMENTS = [
  { key: "etude", label: "Étude technique" },
  { key: "coordination", label: "Coordination tous corps d'état" },
  { key: "suivi", label: "Suivi de chantier" },
  { key: "planning", label: "Respect du planning" },
  { key: "materiaux", label: "Sélection des matériaux" },
  { key: "finitions", label: "Finitions soignées" },
  { key: "decennale", label: "Assurance décennale" },
  { key: "local", label: "Entreprise basée en Île-de-France" },
];

export const PROJECT_FILTERS = [
  { slug: "tous", label: "Tous" },
  { slug: "renovation", label: "Rénovation" },
  { slug: "couverture", label: "Couverture" },
  { slug: "structure", label: "Structure" },
  { slug: "metallerie", label: "Métallerie" },
  { slug: "terrasse", label: "Terrasse" },
  { slug: "isolation", label: "Isolation" },
  { slug: "amenagement-interieur", label: "Aménagement intérieur" },
];

export const CATEGORY_LABELS = PROJECT_FILTERS.reduce((acc, f) => ({ ...acc, [f.slug]: f.label }), {});

export const SERVICES = [
  {
    slug: "renovation-interieure",
    title: "Rénovation intérieure",
    image: IMAGES.interior3,
    text: "De la redistribution des espaces aux finitions, nous rénovons appartements et maisons avec un niveau d'exigence constant.",
    items: ["Appartement", "Maison", "Cuisine", "Salle de bains", "Plâtrerie", "Peinture", "Sols"],
    filter: "renovation",
  },
  {
    slug: "structure",
    title: "Structure",
    image: "/chantiers/structure/05-montage-cadre-acier-grue.webp",
    text: "Ouvertures de murs porteurs, renforcements et structures métalliques, toujours validés par une étude technique préalable.",
    items: ["Ouvertures dans murs porteurs", "Renforcement de structure", "Poutres acier", "HEA / HEB / UPN / UPE", "Création de trémies", "Escaliers métalliques"],
    filter: "structure",
  },
  {
    slug: "couverture",
    title: "Couverture",
    image: IMAGES.roof,
    text: "Réfection complète ou réparation de toitures, avec une zinguerie soignée qui garantit la durabilité de l'ensemble.",
    items: ["Couverture tuile", "Couverture zinc", "Zinguerie", "Étanchéité", "Fenêtres de toit", "Verrières"],
    filter: "couverture",
  },
  {
    slug: "isolation",
    title: "Isolation",
    image: IMAGES.house,
    green: true,
    text: "Isolation intérieure, extérieure ou sarking : nous améliorons la performance énergétique de votre bâtiment de façon cohérente.",
    items: ["Isolation intérieure", "Isolation extérieure", "Sarking", "Isolation toiture", "Amélioration énergétique"],
    filter: "isolation",
  },
  {
    slug: "lots-techniques",
    title: "Lots techniques",
    image: IMAGES.engineer,
    text: "Les réseaux sont la colonne vertébrale d'un chantier réussi : nous les reprenons proprement et aux normes.",
    items: ["Électricité", "Plomberie", "VMC", "Climatisation", "Chauffage"],
    filter: "renovation",
  },
];

export const PROJECT_TYPES = [
  "Rénovation complète",
  "Rénovation partielle",
  "Couverture",
  "Isolation",
  "Structure",
  "Métallerie",
  "Terrasse",
  "Salle de bains",
  "Autre",
];

export const BUDGETS = [
  "Moins de 20 000 €",
  "20 000 € — 50 000 €",
  "50 000 € — 100 000 €",
  "100 000 € — 250 000 €",
  "Plus de 250 000 €",
  "Je ne sais pas encore",
];
